import { render, staticRenderFns } from "./sub-organization.vue?vue&type=template&id=b192207c&scoped=true"
import script from "./sub-organization.vue?vue&type=script&lang=js"
export * from "./sub-organization.vue?vue&type=script&lang=js"
import style0 from "./sub-organization.vue?vue&type=style&index=0&id=b192207c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b192207c",
  null
  
)

export default component.exports